import React, { useState, useEffect } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlay, faPause, faExpand, faCompress } from '@fortawesome/free-solid-svg-icons';
import logo from '../../../assets/images/neophyte_logo.png';
// import axios from 'axios';
import './video.css';
//import vdo from './hola.mkv';
// import { getVideoData } from '../../../../api/sentinelAPI';
import { Box, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { VIDEO_PLAYING } from 'store/actions';

const VideoComponent = () => {
  const [playing, setPlaying] = useState(true);
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [streamUrl, setStreamUrl] = useState('');
  const dispatch = useDispatch();
  const cameraData = useSelector((state) => state.cameraReducer.cameraData);

  console.log('Current cameraData in VideoComponent:', cameraData);

  // Update stream URL when camera changes
  useEffect(() => {
    if (cameraData?.device_name) {
      console.log('Camera changed, updating stream URL for:', cameraData.device_name);
      // For iframe, we'll use a simpler URL format
      const streamUrl = `http://localhost:8889/${cameraData.device_name}`;
      console.log('Setting stream URL:', streamUrl);
      setStreamUrl(streamUrl);
      setPlaying(true);
      dispatch({ type: VIDEO_PLAYING, videoPlaying: true });
    }
  }, [cameraData, dispatch]);

  // const togglePlayPause = () => {
  //   const startVideo = async () => {
  //     // setIsLoading(true);
  //     // const accessToken = localStorage.getItem("accessToken");
  //     // try {
  //     //   const data = await axios.get(`${infer_localUrl}/camera/start`, {
  //     //     // headers: {
  //     //     //   Authorization: `Bearer ${accessToken}`,
  //     //     // },
  //     //   });
  //     //   if (data) {
  //     //     setPlaying(true)
  //     //   }
  //     //   // setStartCamera("http://localhost:9990/camera/start?self");
  //     //   // console.log('Video stream stopped successfully');
  //     // } catch (error) {
  //     //   // console.error('Error stoping video stream:', error);
  //     // }
  //     setPlaying(true);
  //     dispatch({ type: VIDEO_PLAYING, videoPlaying: true });
  //   };

  //   const stopVideo = async () => {
  //     setIsLoading(true);
  //     // const accessToken = localStorage.getItem("accessToken");
  //     setPlaying(false);

  //     try {
  //       const data = await axios.get(`${infer_localUrl}/camera/stop`, {
  //         // headers: {
  //         //   Authorization: `Bearer ${accessToken}`,
  //         // },
  //       });
  //       if (data) {
  //         setIsLoading(false);
  //         dispatch({ type: VIDEO_PLAYING, videoPlaying: false });
  //         window.location.reload();
  //       }
  //       // setStartCamera("http://localhost:9990/camera/start?self");
  //       // console.log('Video stream stopped successfully');
  //     } catch (error) {
  //       // console.error('Error stoping video stream:', error);
  //     }
  //   };

  //   if (!playing) {
  //     startVideo();
  //   } else {
  //     stopVideo();
  //   }
  // };

  // const toggleFullScreen = () => {
  //   if (!isFullScreen) {
  //     if (videoContainerRef.current.requestFullscreen) {
  //       videoContainerRef.current.requestFullscreen();
  //     } else if (videoContainerRef.current.mozRequestFullScreen) {
  //       videoContainerRef.current.mozRequestFullScreen();
  //     } else if (videoContainerRef.current.webkitRequestFullscreen) {
  //       videoContainerRef.current.webkitRequestFullscreen();
  //     } else if (videoContainerRef.current.msRequestFullscreen) {
  //       videoContainerRef.current.msRequestFullscreen();
  //     }
  //   } else {
  //     if (document.exitFullscreen) {
  //       document.exitFullscreen();
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen();
  //     } else if (document.webkitExitFullscreen) {
  //       document.webkitExitFullscreen();
  //     } else if (document.msExitFullscreen) {
  //       document.msExitFullscreen();
  //     }
  //   }
  //   setIsFullScreen(!isFullScreen);
  // };

  return (
    <div className="video-component">
      {isLoading ? (
        <>
          <div style={{ height: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          {playing ? (
            <iframe
              className="border border-black"
              width={'100%'}
              height={'100%'}
              id="videoElement"
              src={streamUrl}
              style={isFullScreen ? { height: '85vh' } : { height: '60vh' }}
              allow="autoplay"
              allowFullScreen
              onError={(e) => {
                console.error('Error loading video stream:', e);
                console.log('Failed stream URL:', streamUrl);
                setPlaying(false);
                dispatch({ type: VIDEO_PLAYING, videoPlaying: false });
              }}
            />
          ) : (
            <div style={isFullScreen ? { height: '85vh' } : { height: '60vh' }} className="flex flex-col justify-center">
              <img src={logo} alt="Neophyte Logo" />
            </div>
          )}
        </>
      )}

      <div className="controls">
        <div className="top-controls"></div>

        <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'center' }}>
          {/* <button onClick={togglePlayPause} className="play-pause-btn">
            <FontAwesomeIcon icon={playing ? faPause : faPlay} />
          </button> */}

          <div className="bottom-controls">
            <input type="text" placeholder="Search" className="search-bar" />
            {/* <button onClick={toggleFullScreen} className="fullscreen-btn">
              {!isFullScreen ? <FontAwesomeIcon icon={faExpand} /> : <FontAwesomeIcon icon={faCompress} />}
            </button> */}
          </div>
        </Box>
      </div>
    </div>
  );
};

export default VideoComponent;
